var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#E4F0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8996 12.334L18.7062 20.7355C18.5987 20.8465 18.4033 20.8465 18.2957 20.7378C14.5853 16.9232 11.6715 13.8649 10.2839 12.334H26.8996ZM9.25 23.2232V13.0029C10.0733 13.9533 11.5487 15.5189 14.1433 18.205L9.25 23.2232ZM22.8659 18.2144L27.75 23.2234V13.2055L22.8659 18.2144ZM18.5011 22.0563C18.9 22.0563 19.2746 21.8967 19.5568 21.6076L22.015 19.087L27.2703 24.4752H9.73078L14.9907 19.0812C15.7272 19.842 16.5424 20.6803 17.4443 21.6076C17.7264 21.8967 18.101 22.0563 18.5011 22.0563Z",
    fill: "#0B5CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.dff09b938dbe9705b7cf757fb1373d24.svg";
export { ForwardRef as ReactComponent };